import axios from 'axios'

export function _arrayBufferToBase64(buffer: ArrayBuffer) {
  let binary = ''
  const bytes = new Uint8Array(buffer)
  const len = bytes.byteLength

  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i])
  }

  return window.btoa(binary)
}

export const getImgAsDataUrl = async (url: string) => {
  const response = await axios.get(url, {
    responseType: 'arraybuffer',
  })
  const base64Image = _arrayBufferToBase64(response.data)
  const contentType = response.headers['content-type']

  return `data:${contentType};base64,${base64Image}`
}
